export default __webpack_public_path__ + "static/media/DeclineLetter2025.287d38a7.pdf";